import React, { useState} from 'react';
import './bookPreview.css'
import { Link } from "react-router-dom"
import { IPlace, BookCommon} from "../../models/Book";
import KeyWord from "../KeyWord/KeyWord";
import useUserStore, {ActionType} from "../../store/userStore";
import {LOGIN_URL} from "../../utilities/API";
import {isHistoryBook} from "../../utilities/typeChecker";

interface BookPreviewProps {
    gridType?:number,
    bookPreview:BookCommon
}

const BookPreview = (props:BookPreviewProps) => {

    const {cartAction,favouriteAction,token, isBookInCart, isBookInFavourite} = useUserStore();
    const [isHover,setIsHover] = useState<boolean>(false);

    const generatePlaces = (places:IPlace[]) => {
        return(
        <div>
            <div>Расположение:</div>
            <div>
                {places.map((value)=>
                    <div key={`place-${value.Place}`}>{`${value.Place} ${value.Room ? `(ауд. ${value.Room})` : ''}. Из ${value.AmountTotal} экз. доступно ${value.InStoreAmount} экз.`}</div>
                )}
            </div>
        </div>
      );
    }

    const onCartClick = () => {
      if(token)
      {
          let typeAction = isBookInCart(props.bookPreview) ? ActionType.Remove : ActionType.Add;
          props.bookPreview.type == 2 && cartAction(props.bookPreview,typeAction);
      }
      else
      {
          const currentUrl = window.location.origin+window.location.pathname+'#/';
          window.location.replace(`${LOGIN_URL}?callback=${currentUrl}`);
      }
    }

    const onFavouriteClick = ()=>{
        if(token)
        {
            let typeAction = isBookInFavourite(props.bookPreview) ? ActionType.Remove : ActionType.Add;
            favouriteAction(props.bookPreview,typeAction);
        }
        else
        {
            const currentUrl = window.location.origin+window.location.pathname+'#/';
            window.location.replace(`${LOGIN_URL}?callback=${currentUrl}`);
        }
    }

    const getActionIcon = () => {
      if(props.bookPreview.type == 3)
      {
          return (<Link target={"_blank"} to={props.bookPreview.link}><i className="bi bi-globe"></i></Link>)
      }
      else if(props.bookPreview.type == 2)
      {
          return (<i
              className={`bi ${isBookInCart(props.bookPreview) ? "bi-cart-x-fill" : "bi-cart-plus"}`}
              onClick={()=>onCartClick()}>
          </i>);
      }
      else {
          return (<Link to={`/document/${props.bookPreview.id}-${props.bookPreview.type}`}><i
              className="bi bi-book-fill"></i></Link>)
      }

    }

    const getFavouriteStarStyle = ()=>{
        if(isHover)
            return "bi-star-half";
        if(isBookInFavourite(props.bookPreview))
            return "bi-star-fill"
        else
            return "bi-star"
    }

    return (
        <div className={`book-preview card col ${props.gridType != null ? `book-preview_type_${props.gridType}` : ""}`}>
            {isHistoryBook(props.bookPreview) &&
            <div className={"card-header book-preview__header"}>
                <div className={"book-preview__header-left"}>
                    <div className={"book-preview__header-issueDate"}>Дата выдачи {props.bookPreview.issueDate}</div>
                    {props.bookPreview.returnDatePlanned && <div className={"book-preview__header-returnDatePlanned"}>
                        Плановая дата возврата {props.bookPreview.returnDatePlanned}
                    </div>}
                </div>
                {props.bookPreview.returnDate && <div className={"book-preview__header-right"}>
                    Дата возврата {props.bookPreview.returnDate}
                </div>}
            </div>
            }
            <div className={"book-preview__content card-body"}>
                <div className={"book-preview__title"}>{props.bookPreview.AuthorName?.replace('|',' ')}</div>
                <div><b>{props.bookPreview.title}</b></div>
                <div>{props.bookPreview.Name}</div>
                {(props.bookPreview.type == 2 && props.bookPreview.pdfUrl)
                    && <Link target={"_blank"} to={props.bookPreview.pdfUrl}>СОДЕРЖАНИЕ</Link>}
                {props.bookPreview.type == 2 && props.bookPreview.Places && generatePlaces(props.bookPreview.Places)}
                {props.bookPreview.type == 2 && props.bookPreview.KeyWords && <KeyWord KeyWords={props.bookPreview.KeyWords}/>}

            </div>
            <div className={"book-preview__footer card-footer"}>
                {getActionIcon()}
                <span>{props.bookPreview.typeName}</span>
                <i onClick={()=>onFavouriteClick()}
                   onMouseEnter={()=>setIsHover(true)}
                   onMouseLeave={()=>setIsHover(false)}
                   className={`bi ${getFavouriteStarStyle()}`}>
                </i>
            </div>
        </div>
    );
};

export default BookPreview;